import React, { FC } from 'react'
import { WrapperVideo } from '../../../../models/others/video'
import ImgUtil from '../../../../utils/img.utils'
import Button from '../../button'
import Typography from '../../typography'
import VideoCta from '../../videoCta/videoCta'
import VideoPlayer from '../../videoPlayer'
import WrapperImage from '../../wrapperImage'

type Props = {
  mainImageSrc: string
  mainImageAlt: string
  cardDetail: any
  pageIsEnglish: boolean
  inEnglishText: string
  categoryIconAlt: string
  categoryIconSrc: string
  cardUrl: string
  images: any
  video: WrapperVideo
  useCase: string
}

export const ImageContainer: FC<Props> = ({
  mainImageSrc,
  mainImageAlt,
  cardDetail,
  pageIsEnglish,
  inEnglishText,
  categoryIconAlt,
  categoryIconSrc,
  cardUrl,
  images,
  video,
  useCase,
}) => {
  const videoOverlayData = {
    imageUrl: mainImageSrc,
    imgAlt: mainImageAlt,
    video: {
      image: video?.image?.file?.url || '',
      altText: video?.altText || '',
      start: video?.start || '',
      animationFile: video?.animationFile?.file?.url || '',
      url: '',
      id: '',
      type: '',
    },
  }

  if (video?.youtubeId) {
    videoOverlayData.video.id = video.youtubeId
    videoOverlayData.video.type = 'youtube'
  }

  if (video?.vimeoId) {
    videoOverlayData.video.id = video.vimeoId
    videoOverlayData.video.type = 'vimeo'
  }

  if (video?.videoUrl) {
    videoOverlayData.video.url = video.videoUrl
    videoOverlayData.video.type = 'html-video'
  }

  if (video?.tencentVideoUrl) {
    videoOverlayData.video.url = video.tencentVideoUrl
    videoOverlayData.video.type = 'tencent-video'
  }

  const renderVideoOverlay = (videoData: any) => {
    return (
      <VideoPlayer
        width={'100%'}
        height="auto"
        videoId={videoData.video.id}
        videoUrl={videoData.video.url}
        type={videoData.video.type}
        img={videoData.imageUrl ? videoData.imageUrl : videoData.video.image}
        backgroundAltText={videoData?.video?.altText}
        backgroundImgParams={'width=732'}
        start={videoData.video.start}
        animationFileUrl={videoData.video.animationFile}
      />
    )
  }

  return (
    <div className="FeaturedResource__Image-Graphic-Outer">
      <div className="FeaturedResource__Image-Container">
        <div className="Image-Position">
          {video ? (
            <div className="FeaturedAsset__Video">
              {renderVideoOverlay(videoOverlayData)}
              <div className="FeaturedResource__arrow-link">
                <VideoCta
                  width={'100%'}
                  height="auto"
                  videoId={videoOverlayData.video.id}
                  videoUrl={videoOverlayData.video.url}
                  type={videoOverlayData.video.type}
                  ctaText={''}
                  ctaType="primary"
                  ctaTheme={'light'}
                  ctaSize={'small'}
                  className="Video__CTA"
                />
              </div>
            </div>
          ) : (
            mainImageSrc && (
              <>
                <WrapperImage
                  className="FeaturedResource__Image"
                  loading="lazy"
                  alt={mainImageAlt}
                  src={ImgUtil.getResizedImageUrl(mainImageSrc, 'width=auto')}
                  width={384}
                  height={384}
                  threshold={650}
                />
                <div className="FeaturedResource__arrow-link">
                  <Button
                    icon={true}
                    href={cardUrl}
                    text={''}
                    type={useCase === 'square' ? 'primary' : 'secondary'}
                    size="small"
                    theme={'light'}
                  />
                </div>
              </>
            )
          )}

          {cardDetail.inEnglish && !pageIsEnglish && (
            <Typography type="microAlt" className="FeaturedResource__Pill">
              {inEnglishText}
            </Typography>
          )}

          {categoryIconSrc && (
            <div className="FeaturedResource__Lower-Icon-Container">
              <WrapperImage
                className="FeaturedResource__Lower-Icon"
                loading="lazy"
                alt={categoryIconAlt}
                src={ImgUtil.getResizedImageUrl(categoryIconSrc, '')}
                width={48}
                height={48}
                threshold={650}
              />
            </div>
          )}

          {(images.companyLogo.url || images.companyColorLogo.url) && (
            <div className="FeaturedResource__Partner-Logo-Container">
              <WrapperImage
                className="FeaturedResource__Partner-Logo"
                loading="lazy"
                alt={
                  images.companyLogo.altText ||
                  images.companyColorLogo.altText ||
                  'UiPath Partner Logo'
                }
                src={ImgUtil.getResizedImageUrl(
                  images.companyLogo.url || images.companyColorLogo.url || '',
                  ''
                )}
                width={240}
                height={240}
                threshold={650}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
